"use client"


import { InputSearchRef } from "../components/SelectPlacement/InputSearch"
import SelectPlacementSkeleton from "../components/SelectPlacement/index.skeleton"

type SelectAirportFromProps = {
  size?: 'small' | 'default'
}

export const refFromAirport: { current: InputSearchRef | null } = { current: null }

const SelectAirportFromSkeleton = ({ size = 'default' }: SelectAirportFromProps) => {

  return (

    <SelectPlacementSkeleton
      size={size}
    />
  )
}

export default SelectAirportFromSkeleton